import React from 'react';
type PavilionLogoProps = {
  className?: string;
};
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/4dRC15Dpk8FLh2nQ6hJhAp/The_Food_Pavilion_Logo_Mockup_-_OPTION_1_TRANSPARENT_WHITE.png';

// The official logo file is a square transparent PNG with generous padding.
// It's used as a mask so the wordmark renders in brand teal, cropped to its
// visible area.
export function PavilionLogo({
  className = ''
}: PavilionLogoProps) {
  const mask = {
    WebkitMaskImage: `url("${LOGO_URL}")`,
    maskImage: `url("${LOGO_URL}")`,
    WebkitMaskRepeat: 'no-repeat',
    maskRepeat: 'no-repeat',
    WebkitMaskPosition: 'center',
    maskPosition: 'center',
    WebkitMaskSize: 'contain',
    maskSize: 'contain'
  } as React.CSSProperties;
  return <span role="img" aria-label="The Food Pavilion — India Basin Waterfront Park" className={`relative block overflow-hidden w-[180px] h-[44px] sm:w-[212px] sm:h-[52px] ${className}`} data-id="element-248" data-mp="5vq84b0enz1a">
      <span aria-hidden="true" style={mask} className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-foodTeal w-[224px] h-[224px] sm:w-[264px] sm:h-[264px]" data-id="element-249" data-mp="2qhi3206pip91" />
    </span>;
}